import { Component, Input } from "@angular/core";
import { SituacaoEnum } from "../util/situacao.enum";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material";
import { PagerComponent } from "../paginator/pager.component";
import { Inscricao } from "../inscricao/inscricao";
import { InscricaoService } from "../inscricao/inscricao.service";

@Component({
  templateUrl: "./inscricao-list.component.html",
  selector: "inscricao-list",
  styleUrls: ["./inscricao-list.component.css"]
})
export class InscricaoListComponent {
  @Input() filtro: Inscricao = new Inscricao();
  @Input() ehAdmin: boolean = false;
  @Input() carregarIniciar: boolean = true;
  public lista: Inscricao[];
  public columnsToDisplay = [
    "codigo",
    "nome",
    "dataInclusao",
    "situacao",
    "periodo",
    "acao"
  ];

  // controla o loading da pagina
  public isLoading: boolean;

  // construtor
  constructor(
    private inscricaoAlunoService: InscricaoService,
    public mensagem: MatSnackBar,  private router: Router,
    private pagerComponent: PagerComponent
  ) {}

  // ngOnInit é executado ao entrar na tela
  ngOnInit() {
    if(this.carregarIniciar){
      this.buscar(this.filtro);
    }
  }

  // busca com filtro
  public buscar(filtro:Inscricao): void {
    this.isLoading = true;
    this.filtro = filtro;
    this.inscricaoAlunoService.filtrar(filtro).subscribe(
      res => {
        this.lista = res;
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }


  // vai para a tela de validação
  editar(codigo: number) {
    this.router.navigate(["/inscricao", codigo, { ehAdmin: this.ehAdmin }]);
  }

  voltarParaNaoConcluido(inscricao: Inscricao){
    inscricao.situacao = SituacaoEnum.NaoConcluido.id;
    this.isLoading = true;
    this.inscricaoAlunoService.update(inscricao).subscribe(result=> {
      this.buscar(this.filtro);
    },  error => this.erro(error));
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem.open(erro, "X", { duration: 5000 });
    this.isLoading = false;
  }

  // finaliza o subscribe
  finaliza() {
    this.isLoading = false;
  }
}
